import React, { useState, useRef } from 'react';

const INITIAL_HEIGHT = 52;
const MAX_HEIGHT = 160;

function TextInputWithButton({ onSubmit, disabled = false }) {
  const [inputValue, setInputValue] = useState("");
  const [shake, setShake] = useState(false);
  const textareaRef = useRef(null);

  const submit = () => {
    if (disabled) return;
    // If the text is empty, trigger a shake animation instead of submitting.
    if (inputValue.trim() === "") {
      setShake(true);
      setTimeout(() => setShake(false), 500); // Shake animation duration 500ms
      return;
    }
    if (onSubmit) onSubmit(inputValue);
    setInputValue("");
    if (textareaRef.current) textareaRef.current.style.height = `${INITIAL_HEIGHT}px`;
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      submit();
    }
  };

  const handleChange = (e) => {
    setInputValue(e.target.value);
    if (textareaRef.current) {
      textareaRef.current.style.height = 'auto';
      const newHeight = Math.min(Math.max(textareaRef.current.scrollHeight, INITIAL_HEIGHT), MAX_HEIGHT);
      textareaRef.current.style.height = `${newHeight}px`;
    }
  };

  return (
    <div className="prompt-composer">
      <textarea
        ref={textareaRef}
        value={inputValue}
        onChange={handleChange}
        onKeyDown={handleKeyDown}
        disabled={disabled}
        placeholder="Ask for code, debugging help, or an explanation…"
        className={shake ? "prompt-textarea is-shaking" : "prompt-textarea"}
        style={{ height: `${INITIAL_HEIGHT}px` }}
      />
      <button
        type="button"
        onClick={submit}
        disabled={disabled}
        className="prompt-submit"
        aria-label={disabled ? "Creating response" : "Send message"}
      >
        {disabled ? <span className="button-spinner" /> : <span aria-hidden="true">↑</span>}
      </button>
    </div>
  );
}

export default TextInputWithButton;
